import { RovoSkillAri } from '@atlassian/ari/rovo/skill';

/**
 * Whether a skill was authored by a user rather than by Atlassian.
 *
 * Custom skills carry a Rovo skill ARI
 * (`ari:cloud:rovo::skill/activation/{activationId}/{skillId}`, where `skillId` is a UUID).
 * Anything else — including `ari:cloud:platform::skill/{skillId}` and third-party connector
 * skills — is treated as Atlassian-provided.
 */
export const isCustomSkill = (skillAri: string): boolean => RovoSkillAri.check(skillAri);
